import { CustomerInfo } from 'app/core/store/customer-info/customer-info.interface';

export const INITIAL_STATE_CUSTOMER_INFO: CustomerInfo = {
  loading: false,
  loaded: false,
  failed: false,
  customer: null,
  defaults: {
    // transport: '',
    localCurrency: 'EUR',
    depot: null,
  },
  restrictions: {
    useCcrValidation: false,
    blankReceiptPossible: false,
    deviationManagement: false,
    overruleMaxQty: false,
    GS1LineRef: false,
    palletExchange: false,
    sealNumberRequired: false,
  },
  places: {},
  flowHandshakeTypes: [],
  allFlowTypes: [],
  flowRegistrationTypes: [],
  orderTypes: [],
  salesOrganisation: {
    id: null,
    contacts: [
    ],
  },
};
